import clsx from "clsx";
import { FileCodeTag } from "../FileCodeTag";
import type { ValueNameProps } from "./types";

export const ValueName = ({ name, fileCode, className }: ValueNameProps) => (
  <span className={clsx("min-w-0 break-words", className)}>
    {name}
    {fileCode !== null && (
      <>
        {" "}
        <FileCodeTag fileCode={fileCode} />
      </>
    )}
  </span>
);
